module.exports = __webpack_public_path__ + "img/19_62.2a5c7605.png";